export default __webpack_public_path__ + "static/media/top-app-explain-smart-phone.23a8bc23.svg";